import { configSelectors } from '@/store/configs'
import useTranslation from './useTranslation'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { generalHelpers } from '@tweddle-se-team/common/helpers'
import { useSelector } from 'react-redux'

const { CUSTOMER_IDS } = customerHelper
const { renamePubType } = generalHelpers

const publicationLabelMapperByCustomer = {
  [CUSTOMER_IDS.SUBARU]: (publicationType, publicationTypes, t) =>
    t(publicationType, renamePubType(publicationTypes, publicationType, 'label')),
  [CUSTOMER_IDS.TME]: (publicationType, publicationTypes, t) =>
    t(renamePubType(publicationTypes, publicationType, 'label'), publicationType),
  [CUSTOMER_IDS.NORDICS]: (publicationType, publicationTypes, t) =>
    t(publicationType, renamePubType(publicationTypes, publicationType, 'label'))
}

export const usePublicationLabel = publicationType => {
  const customerId = useSelector(configSelectors.selectCustomerId)
  const publicationTypes = useSelector(configSelectors.selectConfigByKey('publicationTypes'))
  const t = useTranslation()

  const mapper = publicationLabelMapperByCustomer[customerId] || publicationLabelMapperByCustomer[CUSTOMER_IDS.TME]
  return mapper(publicationType, publicationTypes, t)
}
